"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDidChangeCallback = void 0;
var _react = require("react");
/**
 * A hook that invokes a callback after the given value changed.
 *
 * This is similar to a simple useEffect hook, except that the callback is only called if the given
 * value changes as opposed to any dependency changes. For example, if the callback function itself
 * changes, we don't want to call it again unless the value also changed. Also, useEffect is called
 * on initial render, and we only want to call on subsequent renders.
 *
 * Similar concept to the usePrevious hook:
 * https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 *
 * @param value - The value that will be tracked for changes
 * @param fn - The callback that will be invoked on changes
 * @param dependencies - The dependency array for the callback
 * @return A callback function from useCallback using `fn` and `dependencies`
 */
var useDidChangeCallback = function useDidChangeCallback(value, fn, dependencies) {
  // eslint-disable-next-line zillow/react-hooks/exhaustive-deps
  var callback = (0, _react.useCallback)(fn, dependencies);
  var previous = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    if (value !== previous.current) {
      callback(value, previous.current);
      previous.current = value;
    }
  }, [callback, value]);
  return callback;
};
exports.useDidChangeCallback = useDidChangeCallback;